export default __webpack_public_path__ + "030ab8863c1e2024dc86bc8c17b373c7.png";